import { AttachmentPreviewMethod } from 'owa-attachment-data';
import EventEmitter from 'owa-event-emitter';
import GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import getInitialSxSViewState from 'owa-sxsdata/lib/utils/getInitialSxSViewState';
import { createStore } from 'satcheljs';
import PreviewPaneSelectionSource from './schema/PreviewPaneSelectionSource';
import { EditMode } from './schema/SxSEditState';
import { SaveToCloudStatus } from './schema/SxSExtendedViewState';
import SxSStore from './schema/SxSStore';

const initialStore: SxSStore = {
    shouldShow: false,
    viewState: getInitialSxSViewState(),
    extendedViewState: {
        previewMode: AttachmentPreviewMethod.Unsupported,
        attachmentId: null,
        selectionSource: PreviewPaneSelectionSource.MailList,
        isCloudy: false,
        saveToCloudStatus: SaveToCloudStatus.disabled,
        textPreviewReadMode: GetAttachmentTextPreviewReadMode.AutoDetect,
    },
    editState: {
        mode: EditMode.View,
        editAllowed: false,
        itemId: null,
        isDraft: false,
    },
    customPreviewState: null,
    eventManager: new EventEmitter(),
    pendingPreviewOperation: null,
    pendingNavigation: null,
    readingPaneState: null,
    composeId: null,
    customization: null,
    isInvisible: false,

    shouldUseFakeRightHandSide: false,
    isUsingFakeRightHandSide: false,
    shouldHideReadingPaneOutsideSxS: false,

    attachmentViewStateIdFromListView: null,

    sessionPreviewCount: 0,
    sessionStartTime: 0,
};

initialStore.viewState.previewPane = null;

export const getStore = createStore<SxSStore>('sxsstore', initialStore);
export default getStore();
